import { render, staticRenderFns } from "./CookpitTask.vue?vue&type=template&id=1a5644ea&"
import script from "./CookpitTask.vue?vue&type=script&lang=js&"
export * from "./CookpitTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports